import React from "react";
import { ReactComponent as YourSvg } from "../../assets/logos/ebay.svg";

const EbayIcon = () => {
  return <YourSvg />;
};

export default EbayIcon;
